import React from "react";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import gregorianToJalali from "../../helper/jalaaliDateTime";

const DATE_PATTERN = /^\d{4}-\d{1,2}-\d{1,2}$/;

const formatJalaliDate = (datePart) => {
  if (!DATE_PATTERN.test(datePart)) return datePart;

  const [day, month, year] = String(gregorianToJalali(datePart)).split("-");
  if (!year) return gregorianToJalali(datePart);

  return [
    year,
    month.padStart(2, "0"),
    day.padStart(2, "0"),
  ].join("-");
};

const PersianDateTime = ({value, className = ""}) => {
  if (!value) return "-";

  const normalizedValue = String(value).trim();
  if (!normalizedValue) return "-";

  const [datePart, timePart = ""] = normalizedValue.split(/[ T]+/);
  const jalaliDate = formatJalaliDate(datePart);
  const clock = timePart.split(".")[0].replace(/Z$/, "");
  const ltrTextStyle = {direction: "ltr", unicodeBidi: "isolate"};

  return (
    <span dir="ltr" style={ltrTextStyle} className={`flex flex-col items-center leading-5 ${className}`.trim()}>
      <span dir="ltr" style={ltrTextStyle}>{persianNumberFormat(jalaliDate)}</span>
      {clock && <span dir="ltr" style={ltrTextStyle}>{persianNumberFormat(clock)}</span>}
    </span>
  );
};

export default PersianDateTime;
